import React, { useState, useEffect } from 'react';

const EcommerceScrollToTop = ({ threshold = 350, hasWhatsAppBelow = true }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isWhatsAppOpen, setIsWhatsAppOpen] = useState(() => {
    try {
      return hasWhatsAppBelow && sessionStorage.getItem('sigecom_wa_closed') !== 'true';
    } catch {
      return hasWhatsAppBelow;
    }
  });

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY || document.documentElement.scrollTop;
      if (scrollPosition > threshold) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    const handleWaClosed = () => {
      setIsWhatsAppOpen(false);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('sigecom_whatsapp_closed', handleWaClosed);
    
    // Verificación inicial
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('sigecom_whatsapp_closed', handleWaClosed);
    };
  }, [threshold]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className={`ecom-scroll-top-wrapper ${isVisible ? 'visible' : ''} ${!isWhatsAppOpen ? 'no-whatsapp' : ''}`}>
      <button
        type="button"
        className="ecom-scroll-top-btn"
        onClick={scrollToTop}
        aria-label="Volver arriba"
      >
        <i className="bi bi-chevron-up"></i>
        <span className="ecom-scroll-top-tooltip">Volver arriba</span>
      </button>
    </div>
  );
};

export default EcommerceScrollToTop;
